import { axiosPrivate } from '../api/axios'
import { useEffect } from 'react'
import useRefreshData from './useRefreshData'
import useAuth from './useAuth'

const useAxiosPrivate = () => {
  const refresh = useRefreshData()
  const { auth } = useAuth()

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          // Try to get token from context state
          let token = auth?.token;

          //If state is empty, try to grab it directly from localStorage
          if (!token) {
            try {
              const storedAuth = localStorage.getItem('token');
              token = storedAuth;
            } catch (error) {
              console.error("Error parsing auth from localStorage", error);
            }
          }
          // If we found a token in either place, attach it
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
          }
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true
          const { token } = await refresh()
          prevRequest.headers['Authorization'] = `Bearer ${token}`
          return axiosPrivate(prevRequest)
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept)
      axiosPrivate.interceptors.response.eject(responseIntercept)
    }
  }, [auth, refresh])

  return axiosPrivate
}

export default useAxiosPrivate
